import { MultipleQueriesResponse } from '@algolia/client-search';

import { Market } from 'graphql/generated/graphql';

import { marketToString } from 'helpers/redirectToUserMarketIfNeeded';

import { SearchResponseObject, SearchResults } from './types';

export const localizedSearchableField = (
  fieldName: string,
  locale: string,
): string => {
  if (locale === 'en-US') return `${fieldName}_en_gb`;

  return `${fieldName}_${locale.replace('-', '_').toLowerCase()}`;
};

export const storyMarketsFilter = (
  markets: Market[] | undefined,
  locale: string,
) => {
  if (!markets) return `markets:${locale}`;

  return markets
    .map((market) => `markets:${marketToString(market)}`)
    .join(' OR ');
};

export const parseSearchResults = (
  response: MultipleQueriesResponse<SearchResponseObject>,
  locale: string,
): SearchResults => ({
  queryIds: {
    speakers: response.results[0].queryID || '',
    tags: response.results[1].queryID || '',
    stories: response.results[2].queryID || '',
    genres: response.results[3].queryID || '',
    contentTypes: response.results[4].queryID || '',
    languageIntensities: response.results[5].queryID || '',
  },
  speakers: response.results[0].hits.map((hit) => ({
    id: hit.objectID,
    name: hit.name,
  })),
  tags: response.results[1].hits.map((hit) => ({
    id: hit.objectID,
    name: hit[localizedSearchableField('name', locale)],
  })),
  stories: response.results[2].hits.map((hit) => ({
    id: hit.objectID,
    title: hit.title,
    contentType: {
      slug: hit.content_type.slug,
    },
  })),
  genres: response.results[3].hits.map((hit) => ({
    id: hit.objectID,
    name: hit[localizedSearchableField('name', locale)],
  })),
  contentTypes: response.results[4].hits.map((hit) => ({
    id: hit.objectID,
    name: hit[localizedSearchableField('name', locale)],
    slug: hit.slug,
  })),
  languageIntensities: response.results[5].hits.map((hit) => ({
    id: hit.objectID,
    name: hit[localizedSearchableField('name', locale)],
    slug: hit.slug,
  })),
});
